import type { StorefrontThemeUploadFileDto } from "../../types/storefront-theme-upload"

export const VENDOR_STOREFRONT_THEME_IMAGE_MAX_BYTES = 1024 * 1024 * 1024

export const VENDOR_STOREFRONT_THEME_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
] as const

export const VENDOR_STOREFRONT_THEME_IMAGE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
] as const

export const isVendorStorefrontThemeImageMimeTypeAllowed = (
  mimeType: string
): boolean => {
  const normalized = mimeType.trim().toLowerCase()
  if (!normalized) {
    return false
  }

  return (VENDOR_STOREFRONT_THEME_IMAGE_MIME_TYPES as readonly string[]).includes(
    normalized
  )
}

export const isVendorStorefrontThemeImageFileAllowed = (file: File): boolean => {
  const normalizedName = file.name.trim().toLowerCase()
  const extension = normalizedName.includes(".")
    ? normalizedName.slice(normalizedName.lastIndexOf("."))
    : ""

  if (
    extension &&
    (VENDOR_STOREFRONT_THEME_IMAGE_EXTENSIONS as readonly string[]).includes(
      extension
    )
  ) {
    return true
  }

  return isVendorStorefrontThemeImageMimeTypeAllowed(file.type)
}

export const resolveStorefrontThemeUploadedImageUrl = (
  uploaded: StorefrontThemeUploadFileDto | undefined
): string => {
  const fromUrl = uploaded?.url?.trim()
  if (fromUrl) {
    return fromUrl
  }

  const fromKey = uploaded?.key?.trim()
  if (fromKey && /^https?:\/\//i.test(fromKey)) {
    return fromKey
  }

  throw new Error(
    "Upload succeeded but the server did not return an image URL. Paste a URL or try again."
  )
}
